export const getLocalizedText = (t, language, key, ar, en) =>
  t(key, language === "en" ? en : ar);

export const isCancelledError = (error) =>
  error?.name === "AbortError" ||
  error?.name === "CanceledError" ||
  error?.code === "ABORT_ERR" ||
  error?.code === "ERR_CANCELED" ||
  error?.message === "canceled" ||
  error?.message === "Analysis request was cancelled";

export const createInitialProgress = (getText) => ({
  active: true,
  progress: 10,
  hasStartedRun: false,
  status: "running",
  stage: "preparing-data",
  title: getText("reports.preparingAnalysis", "جاري تجهيز التحليل", "Preparing analysis"),
  description: getText(
    "reports.preparingAnalysisDesc",
    "يتم تجهيز بيانات التقرير قبل إرسالها إلى خدمة الذكاء الاصطناعي.",
    "The report data is being prepared before it is sent to the AI service."
  ),
});

export const createDataReadyProgress = (getText) => ({
  progress: 35,
  hasStartedRun: false,
  stage: "data-ready",
  title: getText("reports.dataReady", "تم تجهيز البيانات", "Data is ready"),
  description: getText(
    "reports.dataReadyDesc",
    "تم تجهيز بيانات التقرير. لم يبدأ التنفيذ لدى الذكاء الاصطناعي بعد.",
    "The report data is ready. AI execution has not started yet."
  ),
});

export const createCompletedProgress = (getText) => ({
  active: true,
  progress: 100,
  hasStartedRun: true,
  status: "completed",
  stage: "completed",
  title: getText("reports.analysisCompleted", "اكتمل التحليل", "Analysis completed"),
  description: getText(
    "reports.analysisCompletedDesc",
    "اكتملت جميع مراحل التحليل وتم عرض النتائج.",
    "All analysis stages were completed and the results are now available."
  ),
});

export const createCancelledProgress = (getText) => ({
  active: true,
  progress: 0,
  hasStartedRun: false,
  status: "cancelled",
  stage: "cancelled",
  title: getText("reports.analysisCancelled", "تم إلغاء التحليل", "Analysis cancelled"),
  description: getText(
    "reports.analysisCancelledDesc",
    "تم إيقاف التحليل قبل اكتماله.",
    "The analysis was stopped before completion."
  ),
});

export const createErrorProgress = (description, getText) => ({
  active: true,
  progress: 0,
  hasStartedRun: false,
  status: "error",
  stage: "error",
  title: getText("reports.analysisError", "خطأ في التحليل", "Analysis error"),
  description:
    description ||
    getText("reports.unknownError", "حدث خطأ غير معروف", "An unknown error occurred"),
});
